import { createSlice } from "@reduxjs/toolkit";
const initialState = { 
  phi_dropdown_values: [],
};

const phiReducer = createSlice({
  name: "phiReducer",
  initialState,
  reducers: {
    setPhiDropdownValues(state, action) {
      state.phi_dropdown_values = action.payload;
    },
  },
});
export const { setPhiDropdownValues } = phiReducer.actions;
export default phiReducer.reducer;
